// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2867":"976aae30","4005":"0615d590","5414":"0615d590","5644":"0615d590","7751":"976aae30","8657":"0615d590"}[chunkId] + ".chunk.css";
};